module.exports = __webpack_public_path__ + "img/truck-dist.22d773d3.svg";